@import '~less/global-variables';
@import '~less/layout/typography';

.nav {
  .font-brand-regular();

  > li > a {
    display: block;
  }
}

.nav-stacked {
  flex-direction: column;

  > li {
    width: 100%;
  }
}

.nav-stacked.nav-pills > li.active > a {
  color: #fff;
  background: @brand-primary;
}

/**
 * Takes less space both horizontal/vertical
 */
.nav-narrow {
  > li {
    > a {
      padding: 5px 10px;
      border: 0;
      &:hover,
      &:focus {
        background-color: transparent;
      }
    }

    // Active state
    &.active > a {
      &,
      &:hover,
      &:focus {
        color: @text-color;
        background-color: transparent;
        font-weight: bold;
      }
    }

    &.active .badge,
    .badge {
      margin-left: 5px;
      background: transparent;
      color: @gray-light;
      border: 1px solid @gray-light;
      font-weight: 200;
      font-size: 11px;
      line-height: 10px;
    }
  }
}

/**
 * Navigation where selected/hovered links are underlined
 */
.nav-underline {
  > li {
    > a {
      border-bottom: 2px solid transparent;
      &:hover,
      &:focus {
        border-radius: 0;
        border-color: @link-hover-color;
      }
    }
    // Active state
    &.active > a {
      border-radius: 0;
      &,
      &:hover,
      &:focus {
        border-color: @brand-secondary;
      }
    }
  }
}

/**
 * Extend navs
 */
.meta-toolbar {
  padding-top: (@grid-gutter-width / 2);
  padding-bottom: (@grid-gutter-width / 2);
  h3 {
    margin: 0 @grid-gutter-width 0 0;
    float: left;
    display: inline-block;
  }
}

.nav-toolbar {
  display: block;
  overflow: hidden;
  font-size: @font-size-small;
  line-height: @font-size-small;
  a {
    padding: 5px 10px;
    .label {
      margin-left: 5px;
    }
  }
}

.nav-toolbar {
  > li {
    > a {
      font-size: @font-size-small;
      line-height: @font-size-small;
      padding: 5px 10px;
    }
  }
}

/**
 * Row toolbar containing tabs
 * Extends Bootstrap .row and .nav-tabs
 */
.row.row-nav-tabs {
  margin-bottom: -1px;
  .nav-tabs {
    background: #f5f5f5;
    border: 1px solid @gray-lighter;
    border-radius: @border-radius-base @border-radius-base 0 0;
    > li > a {
      border-bottom: 1px solid transparent;
    }
    /* Inactive tabs have colorful border on hover */
    > li > a:hover,
    > li > a:focus {
      border-bottom-color: @brand-primary;
    }
    > li.active > a,
    > li.active > a:hover,
    > li.active > a:focus {
      border-top-color: transparent;
      border-bottom-color: transparent;
    }
    > li:first-child > a {
      /* Leftmost tab should not have border, because .nav-tabs already has left border */
      border-left-color: transparent;
      border-top-left-radius: @border-radius-base;
    }
  }
}

.nav-pills > li > a {
  border-radius: @border-radius-base;
}
